import React from 'react';
import showdown from 'showdown';
import PropTypes from 'prop-types';

export const converter = new showdown.Converter({ simpleLineBreaks: true, emoji: true });

showdown.extension('escapemd', function() {
  return [{
    type: 'lang',
    regex: /[\][=~`#|()*_-]/g,
    replace: "\\$&"
  }];
});

export function StripMarkdown(content) {
  const stripConverter = new showdown.Converter({
    simpleLineBreaks: true,
    emoji: true,
    extensions: ['escapemd'],
  });

  return stripConverter.makeHtml(content);
}

export const HTMLContent = ({ content, className }) => (
  <div className={className} dangerouslySetInnerHTML={{ __html: content }} />
);

const Content = ({ content, className, parseMarkdown = true }) => (parseMarkdown ? (
  <HTMLContent content={converter.makeHtml(content)} className={className} />
) : (<div className={className}>{content}</div>));

Content.propTypes = {
  content: PropTypes.string,
  className: PropTypes.string,
  parseMarkdown: PropTypes.bool,
}

HTMLContent.propTypes = Content.propTypes;

export default Content;


// export default ({ content, className }) => <HTMLContent className={className} content={converter.makeHtml(content)} />;
//
// export const HTMLContent = ({ content, className }) => (<div
//   className={className}
//   dangerouslySetInnerHTML={{ __html: content }}
// />);



// WEBPACK FOOTER //
// ./src/components/Content.js